export const SELECTED_CUSTOM_LINE_COLOUR_FOR_DARK_BACKGROUND = 'rgb(236 111 111)';

